// packages/shared/src/pedido.rules.ts
// AIDEV-NOTE: Regras de negocio puras de pedido, compartilhadas entre client e server.
// Sem dependencia de Zod/IO de proposito — sao previsiveis e testaveis isoladamente.

/**
 * Pedido ainda nao sincronizado com o ERP.
 * AIDEV-NOTE: `numero` e atribuido pelo Firebird no push — enquanto for nulo, o pedido
 * existe apenas no app (badge OFFLINE na lista).
 */
export function pedidoNaoSincronizado(pedido: { numero?: number | null }): boolean {
  return pedido.numero == null;
}

/**
 * Pode excluir: rascunho (sempre) ou finalizado/erro_sync que ainda nao foi ao ERP.
 *
 * AIDEV-SECURITY: FONTE UNICA desta regra — usada pela guarda do servidor
 * (pedidos.repository.deletePedido), pelo espelho offline (pedido.service.excluirPedido,
 * onde nao ha backend para defender) e pelos gates de UI (lista e detalhe do pedido).
 * Alterar aqui muda as quatro camadas de uma vez; alterar em uma delas as faz divergir.
 *
 * `sincronizando` fica DE FORA: o push pode estar em voo para o Firebird e a exclusao
 * deixaria o pedido gravado no ERP sem contrapartida no app.
 */
export function podeExcluirPedido(pedido: { status: string; numero?: number | null }): boolean {
  if (pedido.status === 'rascunho') return true;
  if (pedido.status === 'finalizado' || pedido.status === 'erro_sync') {
    return pedidoNaoSincronizado(pedido);
  }
  return false;
}
